import React, { useEffect, useState, useRef } from "react";
import { toast } from "react-toastify";
import { DatePicker, TimePicker, Space } from "antd";
import moment from "moment";
import RichTextEditor from "../../form-input/RichTextEditor";
import MultiSelect from "../../form-input/MultiSelect";

import getFetchConfig from "../../../utils/getFetchConfig";
import handleFetchErrors from "../../../utils/handleFetchErrors";
import standardFetchHandlers from "../../../utils/standardFetchHandlers";
import SelectLocation from "../select-location/SelectLocation";
import { Modal, Button } from "react-bootstrap";
import {
  isTruthyString,
  isValidURL,
  isValidEmailAddress,
  isValidPassword,
  isValidIndianMobileNumber,
  isValidBoolean,
  isDescriptionHas5Words,
} from "../../../utils/verification";
import dayjs from "dayjs";
import { DOMParser } from "../../../utils/DOMParser";
import appURLs from "../../../appURL";
import Inputs from "../../Inputs/Inputs";
import AdsListerInfo from "../ads-lister-info/AdsListerInfo";
import FormButton from "../../buttons/form-button/FormButton";
import PostAdsHeading from "../post-ads-heading/PostAdsHeading";
import AdsPlans from "../ads-plans/AdsPlans";
import AdsPlansUpdated from "../ads-plans/AdsPlansUpdated";
import ImageUpload from "../images-upload/ImageUpload";
import formDataAppender from "../../../utils/formDataAppender";
import CongratulationsScreen from "../congratulations-screen/CongratulationsScreen";
import ThankYouModal from "../updateScreen/ThankYouModal";

import style from "./rentals.module.css";
import { useFetcher } from "react-router-dom";

export default function Rentals({
  toggleModalVisibilty,
  onRoomRentsIdChange,
  adsCategoriesId = ``,
  adsId = "",
  ad_steps = null,
  adsIds,
  setadsIds,
  setReplacerental,
  toggleModalForPostAdscategories,
  post_type,
  onStepChange,
}) {
  const userinfo = JSON.parse(window.localStorage.getItem("user"));

  const fetchConfig = getFetchConfig(),
    appURL = appURLs();

  const optionsForSelectSalary = [
    {
      name: "Please Contact",
      _id: 1,
    },

    {
      name: "Enter Your Amount",
      _id: 2,
    },
  ];

  const optionsForWhoAreYou = [
    {
      name: "Owner",
      _id: "Owner",
    },
    {
      name: "Broker",
      _id: "Broker",
    },
    {
      name: "Company",
      _id: "Company",
    },
  ];

  const [roomTypeRadioBtnOption, updateRoomTypeRadioBtnOption] = useState([]);
  const [rentDetailsData, setrentDetailsData] = useState();
  const [myadsId, setmyadsId] = useState("");
  const [myadsType, setmyadsType] = useState("");
  const [showExitConfirmModal, setShowExitConfirmModal] = useState(false); // First modal
  const [showSaveDraftModal, setShowSaveDraftModal] = useState(false); // Second modal for draft
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showThankYouModal, setShowThankYouModal] = useState(false);

  const availityRadioBtnOtionForRoomRents = [
    {
      label: "Immediate move in",
      value: "Immediate move in",
    },
    {
      label: "Custom date",
      value: "Custom date",
    },
  ];

  const availityRadioBtnOtion = [
    {
      label: "Please contact",
      value: "Please contact",
    },
    {
      label: "Custom date",
      value: "Custom date",
    },
  ];

  const [isPetFriendlyr, setIsPetFriendly] = useState(false);
  // const [isSmokingAllowed, setIsSmokingAllowedR] = useState(false);
  const [contOrdate, setcontOrdate] = useState(false);

  const [locationResponseData, setLocationResponseData] = useState(false);
  const [showLoader, toggleLoader] = useState(false),
    [steps, updateSteps] = useState(0);

  // Notify parent component when step changes
  useEffect(() => {
    if (onStepChange) {
      onStepChange(steps);
    }
  }, [steps, onStepChange]);


  const [lat, setlat] = useState("");
  const [lng, setlng] = useState("");

  const [selectedFiles, setSelectedFiles] = useState([]);
  // const [status,setstatus]=useState('');

  const [jobsDynamicData, updateJobsDynamicData] = useState({});
  const [isContact, setIsConatct] = useState(false);

  const [errorMessage, setErrorMessage] = useState("");
  const [catId, setCatId] = useState("");
  const [roomRentsDynamicData, updateRoomRentsDynamicData] = useState({}),
    [roomRentsAdsId, updateRoomRentsAdsId] = useState(null),
    [imagesDataArr, updateImagesDataArr] = useState([]),
    [preferredAgeArr, updatePreferredAgeArr] = useState([]),
    [selectedTagline, upatedSelectedTagline] = useState([]),
    [isCheckedForFreeNegotiable, toggleIsCheckedForFreeNegotiable] =
      useState(false),
    [rentalTypesCategories, updateRentalTypeCategories] = useState([]),
    [images, updateImage] = useState([]),
    [formData, updateFormData] = useState({
      title: "",
      descriptions: "",
      listerType: "",
      rental_type: "",
      custom_date: null,
      availability: "",
      accommodates: "",
      attachedBath: "",
      rent: null,
      rent_info: roomRentsDynamicData?.rent_info?.[0],
      rent_option: null,
      currency: roomRentsDynamicData?.currency?.[0],
      whoAreU: "",
      is_contact: false,
      category: "",
      isPetFriendly: null,
      isSmokingAllowed: null,
      isAlcoholAllowed: "",
      occupation: "",
      preferredGender: "",
      furnished: "",
      tagline: [],
      location: "",
      latitude: "",
      longitude: "",
      location_name: "",
      prefered_age: [],
      name: JSON.parse(localStorage.getItem(`user`))?.name,
      email_address: JSON.parse(localStorage.getItem(`user`))?.email_address,
      // primary_phone_number: rentDetailsData?.lister_basic_info?.primary_mobile_number?.primary_phone_number
      //     ? rentDetailsData?.lister_basic_info?.primary_mobile_number?.primary_phone_number : JSON.parse(localStorage.getItem(`user`))?.phone_number,
      country_code: "+1",
      secondary_country_code: "+1",
      primary_phone_number: JSON.parse(localStorage.getItem(`user`))
        ?.phone_number,
      secondary_phone_number: "",
      hide_email_address: false,
      hide_phone_number: false,
      website_link: "",
      adsType: "",
      status: "",
    });

  const {
    title,
    descriptions,
    listerType,
    rental_type,
    availability,
    category,
    custom_date,
    accommodates,
    attachedBath,
    rent,
    rent_info,
    rent_option,
    currency,
    whoAreU,
    is_contact,

    isPetFriendly,
    isAlcoholAllowed,
    isSmokingAllowed,
    prefered_age,
    occupation,
    preferredGender,
    furnished,
    location,
    location_name,
    latitude,
    longitude,
    tagline,
    name,
    email_address,
    country_code,
    primary_phone_number,
    secondary_phone_number,
    hide_phone_number,
    hide_email_address,
    website_link,
    adsType,
    status,
  } = formData;

  const [tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState("");

  // Handle typing in the input field (with character limit)
  const handleTagInputChange = (e) => {
    const value = e.target.value;
    if (value.length <= 25) {
      setInputValue(value); // Only update the input if the length is <= 25
    }
  };

  // Add this useEffect in Rentals component
  useEffect(() => {
    if (onRoomRentsIdChange) {
      onRoomRentsIdChange(roomRentsAdsId);
    }
  }, [roomRentsAdsId]);

  // Handle adding a tag (either pressing Enter or clicking the Add button)
  const handleAddTag = () => {
    if (inputValue.trim() && !tags.includes(inputValue)) {
      updateFormData((prevData) => ({
        ...prevData,
        tagline: [...prevData.tagline, inputValue], // Append to tagline array
      }));
      setTags([...tags, inputValue]); // Add the tag to the list
      setInputValue(""); // Clear the input field
    }
  };

  // Handle tag removal
  const handleRemoveTag = (tagToRemove) => {
    setTags(tags.filter((tag) => tag !== tagToRemove)); // Remove the tag from the list
  };

  // Handle the Enter key press
  const handleKeyPress = (e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      handleAddTag();
    }
  };

  const handleChangeCheckkBox = (e) => {
    // Destructuring
    const { value, checked } = e.target;
    if (checked) {
      if (value.toLocaleLowerCase() === `18-any`)
        updatePreferredAgeArr([value]);
      else {
        const filteredData = preferredAgeArr.filter(
          (data) => data.toLocaleLowerCase() !== `18-any`
        );
        updatePreferredAgeArr([...filteredData, value]);
      }
    }
    // Case 2  : The user unchecks the box
    else {
      updatePreferredAgeArr(preferredAgeArr.filter((e) => e !== value));
    }
  };

  const onChangeForDate = (date, dateString) => {
    updateFormData({
      ...formData,
      custom_date: dateString,
    });
  };

  const handleOnChangeFreeRegularFreePrice = () => {
    toggleIsCheckedForFreeNegotiable(!isCheckedForFreeNegotiable);
  };

  function disabledDate(current) {
    return current && current < moment().startOf("day");
    // Disable all dates before today's date
  }

  const onChangeHandlerForForm = (e) => {
    const inputName = e?.target?.name;
    let inputValue = e?.target?.value;

    if (inputName === "country_code") {
      updateFormData((prev) => ({
        ...prev,
        country_code: inputValue,
      }));
      return;
    }
    if (inputName === "secondary_country_code") {
      updateFormData((prev) => ({
        ...prev,
        secondary_country_code: inputValue,
      }));
      return;
    }

    if (
      inputName === `primary_phone_number` ||
      inputName === `secondary_phone_number`
    ) {
      const inputNumber1 = e.target.value.replace(/\D/g, ""); // Remove non-digit characters

      if (inputNumber1.length <= 15) {
        updateFormData((prev) => ({
          ...prev,
          [inputName]: inputValue,
        }));
      }
    }

    if (inputName === "category") {
      const selectedCategory = rentalTypesCategories.find(
        (cat) => cat._id === inputValue
      );
      if (selectedCategory) {
        updateFormData((prev) => ({
          ...prev,
          category: selectedCategory._id, // Update the entire category object, not just the _id
        }));
        setCatId(selectedCategory._id);
      }
    } else if (inputName === "rental_type") {
      const category = roomRentsDynamicData.categories.find(
        (cat) => cat._id === inputValue
      );
      if (category) {
        // Extract subcategory objects
        const subcategories = category.subcategory || [];

        // Update the state for subcategories
        // setCatId(category._id)
        updateRentalTypeCategories(subcategories);
      }
      updateFormData((prev) => ({
        ...prev,
        [inputName]: inputValue,
      }));
    } else {
      updateFormData((prev) => ({
        ...prev,
        [inputName]: inputValue,
      }));
    }
  };

  const [isHideMobileNumberChecked, toggleIsHideMobileNumberChecked] =
    useState(false),
    [isHideEmailAddressChecked, toggleIsHideEmailAddressChecked] =
      useState(false),
    [isHideEmailAddress1Checked, toggleIsHideEmailAddress1Checked] =
      useState(false);

  // lister info
  // const hideEmailNumberSwitchButtonHandler = (e) => {
  //   const inputName = e?.target?.name;

  //   if (inputName === `hide_secondary_phone_number`)
  //     toggleIsHideEmailAddressChecked(!isHideEmailAddressChecked);
  //   if (inputName === `hide_primary_phone_number`)
  //     toggleIsHideMobileNumberChecked(!isHideMobileNumberChecked);
  //   if (inputName === `hide_my_email_address`)
  //     toggleIsHideEmailAddress1Checked(!isHideEmailAddress1Checked);
  // };
  // NEW CODE - CORRECT ✅
  const hideEmailNumberSwitchButtonHandler = (e) => {
    const inputName = e?.target?.name;

    if (inputName === `hide_email_address`)  // Changed this line
      toggleIsHideEmailAddressChecked(!isHideEmailAddressChecked);
    if (inputName === `hide_phone_number`)  // Changed this line
      toggleIsHideMobileNumberChecked(!isHideMobileNumberChecked);
    if (inputName === `hide_my_email_address`)
      toggleIsHideEmailAddress1Checked(!isHideEmailAddress1Checked);
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    toast.dismiss();
    localStorage.removeItem("start_date");
    localStorage.removeItem("end_date");

    const missingData = [],
      invalidData = [];

    // Step 0 - Validation for first step
    if (steps === 0) {
      if (
        !(
          rental_type ||
          category ||
          title ||
          rent ||
          availability ||
          accommodates ||
          attachedBath ||
          whoAreU ||
          tagline ||
          location_name ||
          descriptions
        )
      ) {
        return toast.error("Please provide all data");
      }

      if (!isTruthyString(rental_type))
        missingData.push(
          `Rental type: ${rental_type?._id}${rental_type} ${status}`
        );
      if (!isTruthyString(category)) missingData.push(`Rental category`);
      if (!isTruthyString(title)) missingData.push(`Title`);
      if (!rent_option) missingData.push("Rent option");

      if (Number(rent_option) === 2 && !rent) missingData.push("Rent amount");
      else if (Number(rent_option) === 2 && rent && isNaN(rent))
        invalidData.push("Rent amount");

      if (!isTruthyString(availability)) missingData.push(`Availability`);
      else if (availability === "Custom date" && !isTruthyString(custom_date))
        missingData.push("Availability date");

      if (accommodates && isNaN(accommodates)) missingData.push(`Accommodates`);
      if (attachedBath && isNaN(attachedBath))
        missingData.push(`Attached bath`);
      if (whoAreU && !isTruthyString(whoAreU)) missingData.push(`Who are you`);

      if (rent && (rent < 0 || /^0+$|^0+[1-9][0-9]*$/.test(rent))) {
        return toast.error("Please enter a valid amount");
      }

      if (rental_type === "Rooms for Rent" && !isTruthyString(furnished))
        missingData.push(`Furnished`);

      // Show errors if needed
      if (missingData.length || invalidData.length) {
        if (missingData.length)
          toast.error(`Missing Data:- ${missingData.join(`, `)}`);
        if (invalidData.length)
          toast.error(`Invalid Data:- ${invalidData.join(`, `)}`);
        return;
      } else if (steps !== 4) {
        updateSteps(steps + 1);
      }
    }
    // Step 1 - Validation for second step
    else if (steps === 1) {
      if (!isTruthyString(location_name)) missingData.push("Location");
      else if (!locationResponseData && !adsIds) {
        return toast.error("Please select a location from the suggestions");
      }

      if (!isTruthyString(descriptions)) missingData.push("Description");
      else if (isDescriptionHas5Words(descriptions)) {
        return toast.error(
          "You must write at least 5 words in your description"
        );
      }
      // Show errors if needed
      if (missingData.length || invalidData.length) {
        if (missingData.length)
          toast.error(`Missing Data:- ${missingData.join(`, `)}`);
        if (invalidData.length)
          toast.error(`Invalid Data:- ${invalidData.join(`, `)}`);
        return;
      }
      updateSteps(steps + 1);
    }
    // Step 2 - Validation for third step
    else if (steps === 2) {
      if (
        !(
          name ||
          email_address ||
          primary_phone_number ||
          secondary_phone_number
        )
      ) {
        return toast.error("Please provide all data");
      }

      if (!isTruthyString(name)) missingData.push("Name");
      if (!email_address) missingData.push("Email address");
      else if (email_address && !isValidEmailAddress(email_address))
        invalidData.push("Email address");

      if (!primary_phone_number) missingData.push("Primary phone number");
      else if (primary_phone_number && isNaN(primary_phone_number))
        invalidData.push("Primary phone number");
      else if (
        primary_phone_number &&
        (primary_phone_number.length < 10 || primary_phone_number.length > 15)
      )
        invalidData.push("Primary phone number");

      if (secondary_phone_number && isNaN(secondary_phone_number))
        invalidData.push("Secondary phone number");
      else if (
        secondary_phone_number &&
        (secondary_phone_number.length < 10 ||
          secondary_phone_number.length > 15)
      )
        invalidData.push("Secondary phone number");

      if (
        secondary_phone_number &&
        primary_phone_number === secondary_phone_number
      ) {
        return toast.error(
          "Primary phone number cannot be the same as secondary phone number"
        );
      }

      // Show errors if needed
      // if (missingData.length || invalidData.length) {
      //     if (missingData.length) toast.error(`Missing Data:- ${missingData.join(`, `)}`);
      //     if (invalidData.length) toast.error(`Invalid Data:- ${invalidData.join(`, `)}`);
      //     return;
      // }
      // updateSteps(steps + 1);
      if (missingData.length || invalidData.length) {
        if (missingData.length)
          toast.error(`Missing: ${missingData.join(`, `)}`);
        if (invalidData.length)
          toast.error(`Invalid: ${invalidData.join(`, `)}`);
        return;
      }

      // Close any open modals before proceeding
      setShowExitConfirmModal(false);
      setShowSaveDraftModal(false);
      setShowDeleteModal(false);

      // Handle step progression and modal display
      if (steps === 2 && adsIds && status === "active") {
        // For active ads update, show thank you modal
        setShowThankYouModal(true);
      } else if (steps !== 4) {
        // For other cases, proceed to next step
        updateSteps(steps + 1);
      }
    }

    // if (steps === 2 && adsIds && status === "active") {
    //     // toast.success("Ad edited successfully");
    //     toggleModalVisibilty("roomRents", false);
    //     window.location.reload();

    //     // updateSteps(steps + 1);
    // }

    let formDataObj = {
      negotiable: isCheckedForFreeNegotiable
        ? false
        : isCheckedForFreeNegotiable,
      is_contact,
      amount: rent || 0,
      adsType: adsCategoriesId || adsType,
      rent_info,
      currency: currency || roomRentsDynamicData?.currency?.[0],
      status: status || `draft`,
      rental_type,
      listerType: "",
      roomType: 1,
      preferedGender: "",
      hide_phone_number: isHideMobileNumberChecked,
      hide_email_address: isHideEmailAddressChecked,
      redirect_uri_success: "https://test.menehariya.com/success",
    };

    if (title) formDataObj.title = title;
    if (country_code) formDataObj.country_code = country_code;
    if (category) formDataObj.category = category;
    if (roomRentsDynamicData?.rent_info)
      formDataObj.rent_info = roomRentsDynamicData?.rent_info[0];
    // if (roomRentsDynamicData?.currency) formDataObj.currency = roomRentsDynamicData?.currency[0];
    if (currency) formDataObj.currency = currency;
    if (custom_date) formDataObj.custom_date = custom_date ? custom_date : null;
    if (descriptions) formDataObj.descriptions = descriptions;
    if (preferredAgeArr && preferredAgeArr.length)
      formDataObj.prefered_age = preferredAgeArr;
    if (accommodates) formDataObj.accommodates = accommodates;
    if (attachedBath) formDataObj.attachedBath = attachedBath;
    if (rent) formDataObj.amount = rent;
    if (isCheckedForFreeNegotiable)
      formDataObj.negotiable = isCheckedForFreeNegotiable;
    formDataObj.is_contact = rent === null || rent === 0 ? true : false;
    if (isPetFriendly)
      formDataObj.isPetFriendly =
        isPetFriendly === "1" ? true : isPetFriendly === "2" ? false : null;
    if (isSmokingAllowed)
      formDataObj.isSmokingAllowed =
        isSmokingAllowed === "1"
          ? true
          : isSmokingAllowed === "2"
            ? false
            : null;
    if (isAlcoholAllowed)
      formDataObj.isAlcoholAllowed =
        isAlcoholAllowed === "1"
          ? true
          : isAlcoholAllowed === "2"
            ? false
            : null;
    if (occupation) formDataObj.occupisSmokingation = occupation;
    if (preferredGender) formDataObj.preferedGender = preferredGender;
    if (tagline) formDataObj.tagline = tagline;
    if (whoAreU) formDataObj.listerType = whoAreU !== "" ? whoAreU : "";
    if (furnished) formDataObj.furnished = furnished;
    if (location_name) formDataObj.location_name = location_name;
    if (latitude) formDataObj.latitude = latitude;
    if (longitude) formDataObj.longitude = longitude;
    if (name) formDataObj.name = name;
    if (email_address) formDataObj.email_address = email_address;
    if (primary_phone_number)
      formDataObj.primary_country_code = formData.country_code || "";
    formDataObj.primary_phone_number = primary_phone_number;
    if (secondary_phone_number)
      formDataObj.secondary_country_code =
        formData.secondary_country_code || "";
    formDataObj.secondary_phone_number = secondary_phone_number;
    if (website_link) formDataObj.website_link = website_link;
    if (isHideMobileNumberChecked)
      formDataObj.hide_my_phone = isHideMobileNumberChecked;
    if (isHideEmailAddressChecked)
      formDataObj.hide_my_secondary_phone = isHideEmailAddressChecked;

    const roomRentsFormData = new FormData();

    // Handle photo uploads
    if ((adsId || adsIds) && status === "draft") {
      steps === 2 &&
        selectedFiles.forEach((file) =>
          roomRentsFormData.append("photos", file)
        );
    }

    if (!((adsId || adsIds) && status === "draft")) {
      steps === 2 &&
        selectedFiles.forEach((file) =>
          roomRentsFormData.append("photos", file)
        );
    }

    if (status === "active") {
      steps === 1 &&
        selectedFiles.forEach((file) =>
          roomRentsFormData.append("photos", file)
        );
    }

    const data = formDataAppender(
      formDataObj,
      selectedFiles,
      roomRentsFormData
    );

    if (steps === 1 && !roomRentsAdsId && !adsIds) {
      toggleLoader(true);
      const updatedFetchConfig = fetchConfig;
      delete updatedFetchConfig.headers["Content-Type"];

      fetch(`${appURL}/posts/room-rents`, {
        ...updatedFetchConfig,
        body: data,
      })
        .then(handleFetchErrors)
        .then((res) => {
          localStorage.setItem(
            "advertisementId",
            res.roomtRentObjToSend.advertisement_id
          );
          toggleLoader(false);
          if (res?.status === 200) {
            const roomRentsAdsObjectId = res?.roomtRentObjToSend?._id;
            updateSteps(steps + 1);
            updateRoomRentsAdsId(roomRentsAdsObjectId);
            localStorage.setItem(
              "adsInfo",
              JSON.stringify({
                id: roomRentsAdsObjectId,
                title,
                adsType: "rentals",
                adsCategories: adsCategoriesId,
              })
            );
          } else {
            return toast.error(res?.message);
          }
        })
        .catch((err) => {
          toggleLoader(false);
          console.log(err);
        });
    } else if ((steps === 0 || steps === 1 || steps === 2) && (roomRentsAdsId || adsIds)) {
      toggleLoader(true);
      const updatedFetchConfig = { ...fetchConfig };
      delete updatedFetchConfig.headers["Content-Type"];

      fetch(`${appURL}/posts/room-rents/edit/${roomRentsAdsId || adsIds}`, {
        ...updatedFetchConfig,
        method: "PATCH",
        body: data,
      })
        .then(handleFetchErrors)
        .then((res) => {
          toggleLoader(false);

          if (res?.status === 200) {
            localStorage.setItem(
              "advertisementId",
              res.updateRoomAdObjToSend.advertisement_id
            );

            const rentalsObjId = res?.updateRoomAdObjToSend?._id;
            updateRoomRentsAdsId(rentalsObjId);

            // Close any open modals before proceeding
            setShowExitConfirmModal(false);
            setShowDeleteModal(false);

            // Show thank-you modal for active ads at step 2 only
            if (steps === 2 && status === "active") {
              setShowThankYouModal(true);
            } else {
              updateSteps(steps + 1);
            }
          } else {
            toast.error(res?.message || "Something went wrong while updating");
          }
        })
        .catch((err) => {
          toggleLoader(false);
          toast.error("Failed to update your ad. Please try again.");
        });
    }
  };


  const handleFileChange = (event) => {
    if (!event.target.files || event.target.files.length === 0) {
      return;
    }

    const newFiles = Array.from(event.target.files);

    setSelectedFiles((prevFiles) => {
      // Ensure prevFiles is always an array
      const currentFiles = Array.isArray(prevFiles) ? prevFiles : [];
      const updatedFiles = [...currentFiles, ...newFiles];
      return updatedFiles;
    });
  };

  const callBackFunction = (address = "", lat = "", lng = "") => {
    updateFormData({
      ...formData,
      location_name: address,
      latitude: lat,
      longitude: lng,
    });
  };

  const backBtnClickHandler = () => {
    if (steps === 0) {
      if (roomRentsAdsId || adsId) {
        setShowExitConfirmModal(true);
      } else {
        toggleModalVisibilty("roomRents", false);
      }
    } else {
      updateSteps(steps - 1);
    }
  };

  useEffect(() => {
    if (catId && roomRentsDynamicData?.categories) {
      let matchedCategory = null;

      roomRentsDynamicData.categories.some((category) => {
        const hasSubcategory = category.subcategory.some(
          (subcat) => subcat._id === catId
        );
        matchedCategory = category;

        return hasSubcategory; // Stop iteration if found
      });

      if (matchedCategory) {
        updateRentalTypeCategories(matchedCategory.subcategory);
      } else {
        console.warn(
          "No matching category or subcategory found for ID:",
          catId
        );
      }
    }
  }, [catId]);

  const fetchingDynamicsData = () => {
    fetch(
      `${appURL}/posts/room-rents/dynamics-data?PostType=${adsCategoriesId || "64e48fbcf9eeb14b6e2135c0"
      }`,
      {
        ...fetchConfig,
        method: "GET",
      }
    )
      .then(handleFetchErrors)
      .then((res) => {
        if (res.status === 200) {
          const roomRentsDynamicDataObj = res?.data;
          if (roomRentsDynamicDataObj) {
            updateRoomRentsDynamicData(roomRentsDynamicDataObj);

            // // Create categories options dynamically
            const dynamicCategoriesOptions =
              roomRentsDynamicDataObj.categories.map((category) => ({
                label: category.name,
                value: category._id,
              }));

            // Update state with categories options
            updateRoomTypeRadioBtnOption(dynamicCategoriesOptions);
          }
        } else {
          return toast.error(`Failed to fetch dynamics data`);
        }
      })
      .catch((err) => standardFetchHandlers.error(err));
  };

  //you can see i am getting id in rental_type but unable to show as selected radio button
  const fetchingAdsById = () => {
    let id = adsId || adsIds;
    fetch(`${appURL}/posts/room-rents/ad_details?adsId=${id}`, {
      ...fetchConfig,
      method: "GET",
    })
      .then(handleFetchErrors)
      .then((res) => {
        //  debugger
        if (res?.status === 200) {
          const data = res?.ads_details,
            listerInfo = data?.lister_basic_info,
            adsInfo = data?.adsInfo;
          setrentDetailsData(res?.ads_details?.adsInfo);

          setmyadsId(res?.ads_details?._id);
          setmyadsType(res?.ads_details?.adsType);
          setSelectedFiles(res?.ads_details?.adsInfo?.image);
          setcontOrdate(data?.adsInfo?.availability?.immidiate ? true : false);
          updateFormData((prev) => ({
            ...prev,
            availability: !data?.adsInfo?.availability?.immidiate
              ? "Custom date"
              : "Please contact",
          }));

          updateFormData({
            ...formData,
            rental_type: data?.adsInfo?.rental_type?._id,
          });

          updateFormData({
            ...formData,
            category: data?.adsInfo?.category?._id,
          });

          setCatId(data?.adsInfo?.category?._id);

          updatePreferredAgeArr(adsInfo?.prefered_age);
          setTags(adsInfo?.tagline);
          toggleIsCheckedForFreeNegotiable(adsInfo?.rent?.negotiable);
          const isContact = adsInfo?.rent?.is_contact === true;
          const rentOptionName = isContact
            ? "Please Contact"
            : "Enter Your Amount";
          toggleIsHideMobileNumberChecked(listerInfo?.hide_my_phone || false);
          toggleIsHideEmailAddressChecked(listerInfo?.hide_my_secondary_phone || false);

          const dataObj = {
            ...formData,
            title: adsInfo?.title,
            descriptions: adsInfo?.descriptions,
            whoAreU: adsInfo?.listerType || "",
            rental_type: adsInfo?.rental_type?._id,
            custom_date: adsInfo?.availability?.custom_date,
            availability: availityRadioBtnOtionForRoomRents.find(
              (option) =>
                option.label ===
                (adsInfo?.availability?.immidiate === true
                  ? "Immediate move in"
                  : "Custom date")
            )?.label,
            accommodates: adsInfo?.accommodates,
            attachedBath: adsInfo?.attachedBath,
            category: adsInfo?.category?._id,
            rent: adsInfo?.rent?.amount,
            rent_info: adsInfo?.rent_info,
            rent_option: !adsInfo?.rent?.is_contact ? "2" : "1",
            currency: adsInfo?.rent?.currency,
            // whoAreU: "",
            is_contact: adsInfo?.rent?.is_contact,
            isPetFriendly: adsInfo.isPetFriendly
              ? "1"
              : adsInfo.isPetFriendly === false
                ? "2"
                : "",
            isSmokingAllowed: adsInfo.isSmokingAllowed
              ? "1"
              : adsInfo.isSmokingAllowed === false
                ? "2"
                : "",
            isAlcoholAllowed: adsInfo.isAlcoholAllowed
              ? "1"
              : adsInfo.isAlcoholAllowed === false
                ? "2"
                : "",
            occupation: "",
            preferredGender: adsInfo?.preferedGender,
            furnished: adsInfo?.furnished,
            prefered_age: adsInfo?.prefered_age,
            tagline: adsInfo?.tagline || [],
            location_name: adsInfo?.location?.location_name,
            latitude: adsInfo?.location?.coordinates[1],
            longitude: adsInfo?.location?.coordinates[0],
            name: JSON.parse(localStorage.getItem(`user`))?.name,
            email_address: JSON.parse(localStorage.getItem(`user`))
              ?.email_address,
            secondary_country_code:
              listerInfo?.secondary_mobile_number?.country_code || "+1",
            country_code: listerInfo?.primary_mobile_number?.country_code || "+1",
            primary_phone_number:
              listerInfo?.primary_mobile_number?.primary_phone_number || "",
            // secondary_phone_number: JSON.parse(localStorage.getItem(`user`))
            //   ?.secondary_phone_number,
            secondary_phone_number:
              listerInfo?.secondary_mobile_number?.secondary_phone_number || "",

            hide_email_address: listerInfo?.hide_my_email || false,
            hide_phone_number: listerInfo?.hide_my_phone || false,
            website_link: data?.website_url,
            adsType: data?.adsType,
            status: data.status,
          };

          updateFormData(dataObj);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  useEffect(() => {
    fetchingDynamicsData();
    if (adsId || adsIds) fetchingAdsById();
  }, []);

  // useEffect(() => {
  //     fetchingDynamicsData();
  // }, [])

  let HeadingMessage = `Post your Ad`;
  let SubHeadingMessage = ``;

  if (steps === 3 && !adsIds && status === "draft") {
    HeadingMessage = `Post Your Ad`;
  } else if (steps === 4) {
    SubHeadingMessage = ``;
  } else if (steps === 2) {
    SubHeadingMessage = `Basic Information`;
  }

  const dateFormat = "MM-DD-YYYY";

  const handlingClearSelectInput = (name) => {
    switch (name) {
      case "isPetFriendly":
        updateFormData({
          ...formData,
          isPetFriendly: ``,
        });
        break;

      case "whoAreU":
        updateFormData({
          ...formData,
          whoAreU: ``,
        });
        break;

      case "furnished":
        updateFormData({
          ...formData,
          furnished: ``,
        });
        break;

      case "isSmokingAllowed":
        updateFormData({
          ...formData,
          isSmokingAllowed: ``,
        });

        break;
      case "preferredGender":
        updateFormData({
          ...formData,
          preferredGender: ``,
        });
        break;

      case "attachedBath":
        updateFormData({
          ...formData,
          attachedBath: ``,
        });
        break;

      default:
        break;
    }
    // updateFormData({
    //     ...formData,
    //     isPetFriendly: ``
    // })
  };

  const abcfunction = (data) => {
    setlat(data.lat);
    setlng(data.lng);
  };

  const deleteAd = async () => {
    try {
      // First, verify we have a valid ad ID
      const adIdToDelete = adsIds || roomRentsAdsId; // Use the same ID sources as save function
      if (!adIdToDelete) {
        toast.error("No ad ID found to delete");
        return;
      }

      toggleLoader(true);

      // Use query parameter format as suggested by your endpoint
      const res = await fetch(
        `${appURL}/posts/room-rents/delete-ad?ads_id=${adIdToDelete}`,
        {
          ...fetchConfig,
          method: "DELETE",
        }
      );

      const data = await res.json();

      toggleLoader(false);

      if (data?.status === 200) {
        toast.success("Ad deleted successfully");
        setShowDeleteModal(false);
        setShowExitConfirmModal(false);
        toggleModalVisibilty("localBizServices", false);

        // Clear any stored ad info from localStorage
        localStorage.removeItem("adsInfo");

        // setTimeout(() => {
        //     window.location.href = '/my-ads';
        // }, 1000);
      } else {
        toast.error(data?.message || "Failed to delete ad");
      }
    } catch (err) {
      toggleLoader(false);
      console.error("Error deleting ad:", err);
      toast.error("Something went wrong while deleting ad");
    }
  };

  return (
    <main className={style.main_wrapper}>
      <Modal
        show={showExitConfirmModal}
        onHide={() => setShowExitConfirmModal(false)}
        centered
      >
        <Modal.Header closeButton></Modal.Header>
        <Modal.Body>Save as draft or delete your ad?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="primary"
            onClick={() => {
              setShowExitConfirmModal(false);
              setShowSaveDraftModal(true);
            }}
            style={{
              backgroundColor: "#FFF0E5", // Light shade of #FD7E14
              color: "#FD7E14", // Text color matches main orange
              borderColor: "#FD7E14", // Border matches text
            }}
          >
            Save as Draft
          </Button>
          <Button
            variant="danger"
            onClick={() => {
              setShowExitConfirmModal(false);
              setShowDeleteModal(true);
            }}
            style={{
              backgroundColor: "#FD7E14",
              borderColor: "#FD7E14",
              color: "white", // White text
            }}
          >
            Delete your ad
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showSaveDraftModal}
        onHide={() => setShowSaveDraftModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Save as Draft</Modal.Title>
        </Modal.Header>
        <Modal.Body>Do you want to save this ad as a draft?</Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => setShowSaveDraftModal(false)}
            style={{
              backgroundColor: "#FFF0E5",
              color: "#FD7E14",
              borderColor: "#FD7E14",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="primary"
            onClick={async () => {
              setShowSaveDraftModal(false);
              window.location.reload();
              // await saveDraftAndExit();
            }}
            style={{
              backgroundColor: "#FD7E14",
              borderColor: "#FD7E14",
              color: "white",
            }}
          >
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showDeleteModal}
        onHide={() => setShowDeleteModal(false)}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          Are you sure you want to delete this draft post permanently?
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="light"
            onClick={() => setShowDeleteModal(false)}
            style={{
              backgroundColor: "#FFF0E5",
              color: "#FD7E14",
              borderColor: "#FD7E14",
            }}
          >
            Cancel
          </Button>
          <Button
            variant="danger"
            onClick={async () => {
              setShowDeleteModal(false);
              await deleteAd();
              window.location.reload();
            }}
            style={{
              backgroundColor: "#FD7E14",
              borderColor: "#FD7E14",
              color: "white",
            }}
          >
            Delete
          </Button>
        </Modal.Footer>
      </Modal>

      <ThankYouModal
        show={showThankYouModal}
        onClose={() => {
          setShowThankYouModal(false);
          toggleModalVisibilty("roomRents", false);
          // Optional: reload the page or refresh data
          window.location.reload();
        }}
        message="Ad Updated Successfully!"
        subMessage="Your advertisement has been updated successfully."
      />

      <PostAdsHeading
        headingText={
          (steps === 2 && status === "active") || status === "active"
            ? "Update Your Ad"
            : HeadingMessage
        }
        subHeadingText={SubHeadingMessage}
      />
      {/* <form id={steps === 3 ? undefined : style.room_rents_form}> */}
      <form
        id={
          steps === 3 ? undefined : `room-rents-form ${style.room_rents_form}`
        }
        className={style.room_rents_form}
      >
        {(() => {
          <div></div>;
          if (steps === 0) {
            return (
              <>
                <Inputs
                  label="Rental type"
                  type="radio"
                  required={true}
                  name="rental_type"
                  value={rental_type}
                  // disabled
                  onChangeHandler={onChangeHandlerForForm}
                  id="span-2"
                  radioBtnOtions={roomTypeRadioBtnOption}
                // checked={rental_type === roomTypeRadioBtnOption.value}
                />

                <Inputs
                  label="Category"
                  type="select"
                  required={true}
                  id="span-2"
                  name="category"
                  value={category} // Ensure that this references the _id field of formData.category
                  // disabled={status !== "draft" && (adsIds ? true : false)}
                  onChangeHandler={onChangeHandlerForForm}
                  placeholder="Select category"
                  selectInputOptions={rentalTypesCategories} // Ensure this contains the correct categories
                />

                <Inputs
                  label="Title"
                  type="text"
                  id="span-2"
                  name="title"
                  value={title}
                  required={true}
                  onChangeHandler={onChangeHandlerForForm}
                  placeholder="Enter ad title"
                />

                {
                  <Inputs
                    label="Rent Amount"
                    type="select"
                    id="span-2"
                    required={true}
                    name="rent_option"
                    value={rent_option}
                    adsIds={adsIds}
                    placeholder="Select rent amount"
                    onChangeHandler={onChangeHandlerForForm}
                    selectInputOptions={optionsForSelectSalary}
                  />
                }

                {Number(rent_option) === 2 ? (
                  <div id="span-2">
                    <div className={style.regular_price_wrapper}>
                      <span id="label">
                        Rent Amount <span className="required_field">*</span>
                      </span>

                      <div
                        className={
                          style.free_regular_ticket_price_input_wrapper
                        }
                      >
                        <input
                          checked={isCheckedForFreeNegotiable}
                          name="is_regular_price_free"
                          onChange={handleOnChangeFreeRegularFreePrice}
                          className={style.free_regular_ticket_price_input}
                          type="checkbox"
                          id="vehicle1"
                        />
                        <label htmlFor="vehicle1">Negotiable</label>
                        <br />
                      </div>
                    </div>

                    <div className={style.expected_salary_input_wrapper}>
                      <section>
                        <Inputs
                          inputId={style.currency_input_field}
                          type="select"
                          name="currency"
                          required={true}
                          value={currency}
                          onChangeHandler={onChangeHandlerForForm}
                          selectInputOptions={roomRentsDynamicData?.currency}
                        />
                      </section>
                      <section>
                        <Inputs
                          required={true}
                          inputId={style.rent_input}
                          id="span-2"
                          type="number"
                          name="rent"
                          value={rent}
                          onChangeHandler={onChangeHandlerForForm}
                          placeholder="Enter rent"
                        />
                        <div
                          style={{
                            color: "red",
                            fontSize: "12px",
                            marginTop: "10px",
                          }}
                        >
                          {errorMessage}
                        </div>
                      </section>

                      <section>
                        <Inputs
                          inputClassName={style.salary_input}
                          inputId={style.expected_salary_input_rate}
                          type="select"
                          required={true}
                          name="rent_info"
                          value={rent_info}
                          onChangeHandler={onChangeHandlerForForm}
                          selectInputOptions={roomRentsDynamicData?.rent_info}
                        />
                      </section>
                    </div>
                  </div>
                ) : (
                  ``
                )}

                {/* <section id='span-2'>


                                        <div className={style.regular_price_wrapper}>
                                            <span id='label'>Rent Amount</span>

                                            <div className={style.free_regular_ticket_price_input_wrapper}>
                                                <input checked={isCheckedForFreeNegotiable} name="is_regular_price_free" onChange={handleOnChangeFreeRegularFreePrice} className={style.free_regular_ticket_price_input} type="checkbox" id="vehicle1" />
                                                <label htmlFor="vehicle1">Negotiable</label><br />
                                            </div>

                                        </div>

                                        <Inputs
                                            required={true}
                                            id='span-2'
                                            type='number'
                                            name='rent'
                                            value={rent}
                                            onChangeHandler={onChangeHandlerForForm}
                                            placeholder='Enter rent'
                                        />

                                    </section> */}

                <Inputs
                  label="Availability"
                  required={true}
                  type="radio"
                  name="availability"
                  className={style.availability_input_section_wrapper}
                  inputClassName={style.availability_input_section}
                  value={availability}
                  onChangeHandler={onChangeHandlerForForm}
                  id="span-2"
                  radioBtnOtions={
                    rental_type == "652ce05317e3cbd2d3181a92"
                      ? availityRadioBtnOtionForRoomRents
                      : availityRadioBtnOtion
                  }
                />

                {availability === "Custom date" ? (
                  <section id="span-2">
                    <Space direction="vertical">
                      {/* <span>Select Custom Date<span className='required_field'>*</span></span> */}

                      {/* <DatePicker defaultValue={custom_date ? dayjs(custom_date, dateFormat) : ``} disabledDate={(current) => disabledDate(current, 1)} className={style.date_picter_wrapper} placeholder="Enter your availability date" onChange={(date, dateString) => onChangeForDate(date, dateString, 1)} /> */}

                      <DatePicker
                        defaultValue={custom_date ? dayjs(custom_date) : ""}
                        // disabledDate={(current) => disabledDate(current, 1)}
                        className={style.date_picker_wrapper}
                        placeholder="Enter your availability date"
                        rent_info
                        format="MM-DD-YYYY" // Set the desired date format
                        onChange={(date, dateString) =>
                          onChangeForDate(date, dateString, 1)
                        }
                        disabledDate={(current) => {
                          return (
                            current &&
                            (current.year() > 2030 || disabledDate(current, 1))
                          );
                        }}
                      />
                    </Space>
                  </section>
                ) : (
                  ``
                )}

                {rental_type !== "Other Rentals" &&
                  rental_type !== "Commercial Property for Rent" ? (
                  <>
                    {/* 
                                                <Inputs
                                                    label='Smoking allowed?'
                                                    type='radio'
                                                    name='isSmokingAllowed'
                                                    value={isSmokingAllowed}
                                                    onChangeHandler={onChangeHandlerForForm}
                                                    radioBtnOtions={[{
                                                        label: 'Yes',
                                                        value: '1'
                                                    },
                                                    {
                                                        label: 'No',
                                                        value: '2'
                                                    }]}
                                                /> */}

                    {/* <Inputs
                                                    label='Smoking allowed?'
                                                    name='isSmokingAllowed'
                                                    value={isSmokingAllowed}
                                                    handlingClearSelectInput={handlingClearSelectInput}
                                                    onChangeHandler={onChangeHandlerForForm}
                                                    type='select'
                                                    placeholder='Select'
                                                    selectInputOptions={[{
                                                        name: 'Yes',
                                                        _id: '1'
                                                    },
                                                    {
                                                        name: 'No',
                                                        _id: '2'
                                                    }]}
                                                /> */}

                    <Inputs
                      label="Smoking allowed?"
                      name="isSmokingAllowed"
                      value={isSmokingAllowed}
                      // handlingClearSelectInput={handlingClearSelectInput}
                      handlingClearSelectInput={handlingClearSelectInput}
                      onChangeHandler={onChangeHandlerForForm}
                      type="select2"
                      placeholder="Select"
                      selectInputOptions={[
                        {
                          name: "Yes",
                          _id: "1",
                        },
                        {
                          name: "No",
                          _id: "2",
                        },
                      ]}
                    />

                    {/* <div>
                                                    <span id='label'>Pet Friendly?(Optional)</span>
                                                    <div className="radio">
                                                        <input onChange={onChangeHandlerForForm} name="isPetFriendly" checked={isPetFriendly} value={false} id="isPetFriendly1" type="radio" />
                                                        <label htmlFor='isPetFriendly1' className="radio-label">Yes</label>
                                                    </div>
                                                    <div className="radio">
                                                        <input onChange={onChangeHandlerForForm} name="isPetFriendly" value={true} id="isPetFriendly" type="radio" />
                                                        <label htmlFor='isPetFriendly' className="radio-label">No</label>
                                                    </div>
                                                </div> */}

                    <Inputs
                      label="Pet Friendly?"
                      name="isPetFriendly"
                      handlingClearSelectInput={handlingClearSelectInput}
                      value={isPetFriendly}
                      onChangeHandler={onChangeHandlerForForm}
                      type="select2"
                      placeholder="Select"
                      selectInputOptions={[
                        {
                          name: "Yes",
                          _id: "1",
                        },
                        {
                          name: "No",
                          _id: "2",
                        },
                      ]}
                    />

                    {/* <Inputs
                                                    label='Pet Friendly?'
                                                    type='radio'
                                                    name='isPetFriendly'
                                                    value={isSmokingAllowed}
                                                    onChangeHandler={onChangeHandlerForForm}
                                                    radioBtnOtions={[{
                                                        label: 'Yes',
                                                        value: '3'
                                                    },
                                                    {
                                                        label: 'No',
                                                        value: '4'
                                                    }]}
                                                /> */}

                    <Inputs
                      label="Attached bath"
                      handlingClearSelectInput={handlingClearSelectInput}
                      type="select2"
                      name="attachedBath"
                      value={attachedBath}
                      updateState={updateFormData}
                      // handlingClearSelectInput={handlingClearSelectInput}
                      onChangeHandler={onChangeHandlerForForm}
                      placeholder="Select number of baths"
                      selectInputOptions={
                        roomRentsDynamicData?.attachedBathRoom
                      }
                    />
                  </>
                ) : (
                  ``
                )}

                {rental_type === "Rooms for Rent" ||
                  rental_type === "Commercial Property for Rent" ? (
                  <Inputs
                    label="Furnished"
                    required={
                      rental_type === "Commercial Property for Rent"
                        ? false
                        : true
                    }
                    name="furnished"
                    handlingClearSelectInput={
                      rental_type === "Commercial Property for Rent"
                        ? handlingClearSelectInput
                        : ``
                    }
                    // handlingClearSelectInput={handlingClearSelectInput}
                    value={furnished}
                    onChangeHandler={onChangeHandlerForForm}
                    type={
                      rental_type === "Commercial Property for Rent"
                        ? "select2"
                        : "select"
                    }
                    placeholder="Select furnished type"
                    selectInputOptions={roomRentsDynamicData?.furnished}
                  />
                ) : (
                  ``
                )}
                {rental_type !== "Other Rentals" && (
                  <>
                    <Inputs
                      label="Accommodates"
                      type="number"
                      name="accommodates"
                      formData={formData}
                      updateState={updateFormData}
                      value={accommodates}
                      // onChangeHandler={onChangeHandlerForForm}
                      onChangeHandler={(e) => {
                        const inputValue = e.target.value;
                        if (inputValue.length <= 4) {
                          onChangeHandlerForForm(e);
                        }
                      }}
                      // onChangeHandler={(e) => {
                      //     const inputValue = e.target.value;
                      //     // Ensure the value is a number and limit to 4 digits
                      //     if (/^\d{0,4}$/.test(inputValue)) {
                      //       onChangeHandlerForForm(e);
                      //     }
                      //   }}
                      placeholder="Enter accommodates"
                    />

                    <Inputs
                      label="Who are you?"
                      type="select2"
                      name="whoAreU"
                      handlingClearSelectInput={handlingClearSelectInput}
                      value={whoAreU}
                      onChangeHandler={onChangeHandlerForForm}
                      placeholder="Select"
                      selectInputOptions={optionsForWhoAreYou}
                    />
                  </>
                )}
              </>
            );
          } else if (steps === 1) {
            return (
              <>
                {rental_type === "652ce05317e3cbd2d3181a92" ? (
                  <>
                    <Inputs
                      name="prefered_age"
                      selectOptionArrForCheckBox={preferredAgeArr}
                      onChangeHandler={handleChangeCheckkBox}
                      label="Preferred age"
                      type="checkbox"
                      id="span-2"
                      checkboxInputOtions={roomRentsDynamicData?.prefered_age}
                    />

                    <Inputs
                      label="Preferred gender"
                      type="select2"
                      id="span-2"
                      name="preferredGender"
                      value={preferredGender}
                      handlingClearSelectInput={handlingClearSelectInput}
                      onChangeHandler={onChangeHandlerForForm}
                      placeholder="Select preferred gender"
                      selectInputOptions={roomRentsDynamicData?.gender}
                    />
                  </>
                ) : (
                  ``
                )}

                <section id="span-2">
                  <div>
                    <label className="tagline-main">Tagline (optional)</label>
                    <div>
                      <input
                        type="text"
                        name="tagline"
                        value={inputValue}
                        onChange={handleTagInputChange}
                        onKeyPress={handleKeyPress}
                        placeholder="Enter tagline"
                      />
                      <button
                        onClick={handleAddTag}
                        style={{ display: "none" }}
                      >
                        Add Tag
                      </button>
                    </div>

                    <div>
                      {tags.length > 0 && (
                        <div>
                          {tags.map((tag, index) => (
                            <span
                              key={index}
                              style={{
                                margin: "5px",
                                padding: "5px",
                                border: "1px solid #ccc",
                                display: "inline-block",
                              }}
                            >
                              {tag}
                              <button
                                onClick={() => handleRemoveTag(tag)}
                                style={{
                                  marginLeft: "5px",
                                  cursor: "pointer",
                                  background: "red",
                                  color: "white",
                                  border: "none",
                                  borderRadius: "50%",
                                  width: "20px",
                                  height: "20px",
                                }}
                              >
                                ×
                              </button>
                            </span>
                          ))}
                        </div>
                      )}
                    </div>

                    {/* Display message if the limit is exceeded */}
                    {inputValue.length > 25 && (
                      <p style={{ color: "red" }}>
                        Tag must be less than 25 characters
                      </p>
                    )}
                  </div>
                </section>

                {/* <section id='span-2'>
                                    <MultiSelect
                                        label='Tagline'
                                        id='tagline'
                                        value={selectedTagline}
                                        allowCreate={true}
                                        onCreate={onCreateteHandler}
                                        name='tagline'
                                        data={roomRentsDynamicData?.data?.tagline}
                                        dataKey="keywords"
                                        textField="name_email"
                                        placeholder="Enter tagline"
                                        onChange={(admin) => upatedSelectedTagline(admin)}
                                        onInputChange={(input) => {
                                            // Truncate input to 25 characters
                                            if (input.length > 25) {
                                                console.warn("Maximum character limit is 25.");
                                                return input.slice(0, 25); // Truncated input
                                            }
                                        }}
                                    />
                                </section> */}

                <SelectLocation
                  callBackFunction={callBackFunction}
                  location={location_name}
                  latitude={latitude}
                  longitude={longitude}
                  //    abc={abcfunction}
                  locationResponseData={locationResponseData}
                  setLocationResponseData={setLocationResponseData}
                  required={true}
                />

                {/* <Inputs
                                    label='Description'
                                    type='textarea'
                                    required={true}
                                    name='descriptions'
                                    value={descriptions}
                                    onChangeHandler={onChangeHandlerForForm}
                                    placeholder='Enter description'
                                    id='span-2'
                                /> */}

                <RichTextEditor
                  value={descriptions}
                  updateFormData={updateFormData}
                  formData={formData}
                  label="Description"
                  required={true}
                />

                {/* <input type="file" name='photos' onChange={handleFileChange} multiple/> */}

                <ImageUpload
                  images={images}
                  updateImage={updateImage}
                  handleFileChange={handleFileChange}
                  setSelectedFiles={setSelectedFiles}
                  selectedFiles={selectedFiles}
                  myadsId={myadsId}
                  myadsType={myadsType}
                />
              </>
            );
          } else if (steps === 2) {
            return (
              <AdsListerInfo
                onChangeHandler={onChangeHandlerForForm}
                formData={formData}
                isHideMobileNumberChecked={isHideMobileNumberChecked}
                isHideEmailAddressChecked={isHideEmailAddressChecked}
                isHideEmailAddress1Checked={isHideEmailAddress1Checked}
                hideEmailNumberSwitchButtonHandler={
                  hideEmailNumberSwitchButtonHandler
                }
              />
            );
          } else if (steps === 3 && !adsIds) {
            return (
              <AdsPlansUpdated
                steps={steps}
                updateSteps={updateSteps}
                adsId={roomRentsAdsId}
                adsCategoriesId={adsCategoriesId}
              />
            );
          } else if (steps === 3 && adsIds && status != "active") {
            return (
              <AdsPlansUpdated
                steps={steps}
                updateSteps={updateSteps}
                adsId={roomRentsAdsId}
                adsCategoriesId={adsCategoriesId || adsType}
                adsIds={adsIds}
              />
            );
          }
          else if (steps === 4) {
            return <CongratulationsScreen />;
          }
        })()}

        {/* (steps !== 4 && steps !== 3) */}
        {steps !== 4 && steps !== 3 && (
          // <FormButton
          //     cancelButtonText='Back'

          //     submitBtnText={(steps === 2 && status === 'active') ? "Update My Ad" :
          //         (steps === 3 && status === 'draft' && (adsIds || adsId)) ? "Post My Ad" : "Next"}
          //     // submitBtnText={
          //     //     (steps === 2 && (adsIds || roomRentsAdsId)) ? "Update My Ad" :
          //     //         // (steps === 2) ? "Next"
          //     //         // :
          //     //             (steps === 3 && status === 'draft' && (adsIds || adsId)) ? "Post My Ad" :
          //     //                 "Next"
          //     // }
          //     id="span-2"
          //     className={style.form_button_section}
          //     backBtnClickHandler={backBtnClickHandler}
          //     onClickHandler={handleFormSubmit}
          //     showLoader={showLoader}
          // />
          <FormButton
            cancelButtonText={(adsId || adsIds) && steps === 0 ? null : "Back"}
            submitBtnText={
              steps === 2 && status === "active"
                ? "Update My Ad"
                : steps === 3 && status === "draft" && (adsIds || adsId)
                  ? "Post My Ad"
                  : "Next"
            }
            id="span-2"
            className={style.form_button_section}
            backBtnClickHandler={backBtnClickHandler}
            onClickHandler={handleFormSubmit}
            showLoader={showLoader}
          />
        )}
      </form>
    </main>
  );
}


